import { useContext, useState } from "react";
import DataContext from "../store/data-context";

const useSendForm = () => {
    const { setError, setLoading, setFormSent } = useContext(DataContext);

    const sendForm = async (data = { name: "test" }) => {
        try {
            setLoading(true);

            const response = await fetch(`/order-form/send`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ...data }),
            });

            setLoading(false);
            if (response) {
                const value = await response.json();
                setFormSent(true);
                return value;
            } else {
                setError({
                    message:
                        "Problem sa slanjem upita. Pokušajte ponovo kasnije.",
                    action: "zatvori",
                });
                console.log("error");
                return false;
            }
        } catch (err) {
            setError({
                message: "Problem sa slanjem upita. Pokušajte ponovo kasnije.",
                action: "zatvori",
            });
            setLoading(false);
            console.log("ERROR");
            throw new Error(err);
        }
    };

    return { sendForm };
};

export default useSendForm;
